const Content = require('./content');
const signals = require('../../signals/auth');

class Auth {
    constructor () {
        this.template = require('./template.hbs');
    }

    bind () {
        // Тк при серверном редиректе нельзя поставить куку, делаем проверку на редирект уже после загрузки страницы
        this.$context.signal(signals.checkForAuthCookie);
    }

    render () {
        return this.$context.getWatcherData();
    }
}

module.exports = {
    constructor: Auth,
    children: [
        {
            name: 'content',
            component: Content,
            watcher: {
                components: ['page', 'components']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/auth/index.js